import { addStyles } from 'ethcss'
import { IStyles, mediaCSS, palette } from '../../theme'
import { colors } from 'theme/colors'

const settingsStyles: IStyles = {
    companyWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        color: palette.neutral[800],
        fontSize: 18,
        borderBottom: `1px solid ${colors.grey}`,
        paddingBottom: 20,
        marginBottom: 24,

        [mediaCSS.desktopL]: {
            display: 'block',
            fontSize: 14,

            [mediaCSS.tabMini]: {
                paddingTop: 54,
                marginBottom: 24,
            },
        },
    },
    companyName: {
        fontSize: 24,
        fontWeight: 700,
        marginBottom: 20,

        [mediaCSS.tabMini]: {
            fontSize: 18,
            marginBottom: 14,
        },
    },
    companyLeft: {},
    companyRow: {
        padding: '4px 0',
    },
    companyRight: {
        display: 'flex',
        textAlign: 'center',
        paddingTop: 46,
        maxWidth: 740,

        [mediaCSS.desktopL]: {
            maxWidth: '100%',

            [mediaCSS.tabMini]: {
                display: 'block',
                paddingTop: 6,
            },
        },
    },
    companyBlock: {
        position: 'relative',
        borderRadius: 10,
        padding: 20,

        [mediaCSS.tabMini]: {
            display: 'flex',
            padding: 0,
            marginBottom: 6,
        },
    },
    deviceIcon: {
        position: 'absolute',
        top: -16,
        left: '50%',
        transform: 'translateX(-50%)',
        padding: 4,
        backgroundColor: `var(--var-module-app-component-app-style-background, ${colors.white})`,

        [mediaCSS.tabMini]: {
            display: 'none',
        },
    },
    companyBlockWithBorder: {
        border: `1px solid ${colors.grey}`,

        [mediaCSS.tabMini]: {
            border: 'none',
        },
    },
    count: {
        fontSize: 32,
        fontWeight: 700,
        marginTop: 24,

        [mediaCSS.tabMini]: {
            fontSize: 14,
            marginTop: 0,
            marginLeft: 6,
        },
    },
    licensesBlock: {
        fontSize: 18,
        color: colors.white,

        [mediaCSS.desktopL]: {
            fontSize: 14,
        },
    },
    ellipsis: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        [mediaCSS.desktopL]: {
            textOverflow: 'clip',
            overflowX: 'auto',
            overflowY: 'clip',
            '&::-webkit-scrollbar': {
                height: '5px',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                height: '5px',
                background: colors.middleGrey,
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent',
                borderRadius: '10px',
            },
        },
    },
    licensesRow: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        letterSpacing: 1.2,
        padding: 20,
        borderRadius: 5,
        boxShadow: '0px 4px 4px 0px #00000040',
        marginBottom: 20,
        overflow: 'hidden',

        [mediaCSS.desktopL]: {
            flexWrap: 'wrap',

            [mediaCSS.tabMini]: {
                padding: 10,
            },
        },
    },
    licensesCol: {},
    licensesCol_1: {
        table: {
            fontWeight: 'bold',
            fontSize: 16,

            [mediaCSS.desktopML]: {
                fontSize: 14,

                [mediaCSS.desktopL]: {
                    marginBottom: 20,
                },
            },

            td: {
                paddingTop: 8,
            },
            'tr:first-child': {
                fontWeight: 'normal',
                fontSize: 14,

                td: {
                    paddingTop: 0,
                    paddingBottom: 8,
                },
            },
            'td:last-child': {
                paddingLeft: 16,
            },
        },
    },
    licensesCol_2: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        textAlign: 'center',

        [mediaCSS.desktopL]: {
            justifyContent: 'flex-start',

            [mediaCSS.tabMini]: {
                position: 'absolute',
                top: 40,
                right: 10,
            },
        },
    },
    daysLeft: {
        fontSize: 16,

        [mediaCSS.desktopML]: {
            fontSize: 14,
        },
    },
    daysLeftCount: {
        marginTop: 10,
        fontSize: 32,

        [mediaCSS.desktopML]: {
            fontSize: 26,
        },
    },
    licensesCol_3: {
        display: 'flex',
        fontSize: 16,
        width: '63%',

        [mediaCSS.desktopML]: {
            fontSize: 14,
            width: '54%',

            [mediaCSS.desktopL]: {
                width: '100%',

                [mediaCSS.tabMini]: {
                    display: 'block',
                },
            },
        },
    },
    tariffWrapper: {
        width: '29%',
        textAlign: 'center',
        fontWeight: 'bold',
        borderRadius: 10,
        border: `1px solid ${palette.white[400]}`,
        backgroundColor: palette.white[300],
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        [mediaCSS.tabMini]: {
            width: '100%',
            marginBottom: 10,
            padding: 10,
        },
    },
    tariffTitle: {
        marginBottom: 10,
    },
    details: {
        width: '71%',
        textAlign: 'center',
        fontWeight: 'bold',
        borderRadius: 10,
        backgroundColor: palette.white[100],
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: 20,
        marginLeft: 10,

        [mediaCSS.desktopML]: {
            fontSize: 14,

            [mediaCSS.tabMini]: {
                padding: 10,
                flexWrap: 'wrap',
                width: '100%',
                marginLeft: 0,
            },
        },
    },
    availableTitle: {
        marginBottom: 10,
    },
    availableCount: {
        fontSize: 32,

        [mediaCSS.desktopML]: {
            fontSize: 26,
        },
    },
    usedTitle: {
        marginBottom: 10,
    },
    usedCount: {
        fontSize: 32,

        span: {
            fontSize: 20,
            color: 'rgba(255,255,255,0.3)',

            [mediaCSS.desktopML]: {
                fontSize: 20,
            },
        },

        [mediaCSS.desktopML]: {
            fontSize: 26,
        },
    },
    detailsLinkedDevices: {
        [mediaCSS.desktopML]: {
            width: '33%',

            [mediaCSS.tabMini]: {
                width: '100%',
                marginTop: 20,
            },
        },
    },
    viewDevices: {
        backgroundColor: colors.white,
        display: 'flex',
        padding: '10px 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        flex: '1 0 0',
        borderRadius: 5,
        cursor: 'pointer',

        [mediaCSS.tabMini]: {
            fontSize: 12,
        },
    },
    timeLeftAndCount: {
        justifyContent: 'space-between',
        width: 340,

        [mediaCSS.desktopL]: {
            display: 'flex',
            width: 240,

            [mediaCSS.tabMini]: {
                display: 'block',

                span: {
                    display: 'block',
                },
            },
        },
    },
    licenseStatus: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        width: 280,
        zIndex: 1,

        [mediaCSS.desktopL]: {
            width: 190,

            [mediaCSS.tabMini]: {
                display: 'block',
            },
        },
    },
    licenseType: {
        width: 150,

        [mediaCSS.desktopL]: {
            width: 90,
        },
    },
    accentLabel: {
        position: 'absolute',
        right: 0,
        top: 0,
        height: '100%',
        width: 354,
        borderRadius: '0 0 0 40px',
        background: colors.blueAccent,

        [mediaCSS.desktopL]: {
            width: 236,

            [mediaCSS.tabMini]: {
                display: 'none',
            },
        },
    },
    accentFrame: {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        left: 0,
        border: `4px solid ${colors.blueAccent}`,
        pointerEvents: 'none',
    },
    activateBtn: {
        borderRadius: 5,
        backgroundColor: 'rgba(0,0,0,0.4)',
        padding: 10,
        cursor: 'pointer',
    },
    modal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 9999,
    },
    modalInner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
        width: 450,
        height: 520,
        borderRadius: 20,
        backgroundColor: colors.white,
        backgroundImage: 'url("images/licenses/gift_background.jpg")',
        backgroundPosition: 'left -30px bottom 0',
        backgroundSize: '480px',
        backgroundRepeat: 'no-repeat',
        padding: 44,
        textAlign: 'center',
    },
    giftCaption: {
        fontSize: 36,
        fontWeight: 700,
    },
    giftText: {
        fontSize: 24,
        color: colors.white,
        marginTop: 340,
        lineHeight: 1.3,
    },
    modalClose: {
        position: 'absolute',
        top: 20,
        right: 20,
    },
    gift: {
        position: 'absolute',
        left: 14,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    giftPadding: {
        paddingLeft: '53px !important',
    },
    licenceActionsButtons: {
        position: 'relative',
        display: 'flex',
        marginBottom: 14,

        [mediaCSS.desktopML]: {
            flexWrap: 'wrap',
        },
    },
    licenceActionButton: {
        position: 'relative',
        marginRight: 20,
        padding: '12px 20px',
        border: '1.5px solid #E7EAF2',
        borderRadius: '8px !important',
        backgroundColor: colors.white,
        color: colors.blackLight,
        fontWeight: 'bold',
        marginBottom: 10,

        '&:last-child': {
            position: 'absolute',
            right: -20,
            top: 0,

            [mediaCSS.desktopML]: {
                position: 'static',
            },
        },

        [mediaCSS.tabMini]: {
            width: '100%',
            marginRight: 0,
            display: 'flex',
            justifyContent: 'center',
        },
    },
    redError: {
        color: colors.error,
        paddingTop: '5px',
    },
    requestLicensesModal: {
        position: 'fixed',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 9999,
    },
    requestLicensesModalInner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        width: 450,
        padding: 40,
        borderRadius: 20,
    },
    requestLicensesFieldWrapper: {
        marginBottom: 20,
    },
    requestLicensesFields: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    halfField: {
        width: '48%',
    },
    halfFieldForDate: {
        width: '48%',
        zIndex: 9,
    },
    createFileButtons: {
        display: 'flex',
        justifyContent: 'center',
    },
    createFileButton: {
        margin: '0 14px',
    },
    uploadLicenseStatus: {
        position: 'fixed',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 9999,
    },
    uploadLicenseStatusInner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        width: 450,
        padding: 40,
        borderRadius: 20,
    },
    uploadText: {
        marginBottom: 46,
        fontSize: 18,
        color: colors.grey,
        textAlign: 'center',
    },
    uploadLicenseStatusClose: {
        position: 'absolute',
        top: 16,
        right: 16,
    },
    licenceInputFile: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        opacity: 0,
    },
    viewBtnInner: {
        display: 'flex',
    },
    viewBtnInnerIcon: {
        marginRight: 10,
    },
    disabled: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
}

addStyles(settingsStyles)
export default settingsStyles
